import { Injectable } from '@angular/core';
import { Common } from './common';

export type LocalStorageItem = 'Token' | 'SubmittedQuestionnaires';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  setServerToken(value: string): void {
    if (Common.isNullOrEmpty(value)) {
      return;
    }
    this.setItem('Token', value);
  }

  getServerToken(): string | null | undefined {
    return this.getItem('Token');
  }

  setSubmittedQuestionnaire(restaurantId: string, reservationId: string | null, customerId: string | null, averageRating: number, submissionId: number | null) {
    const submittedQuestionnaires = this.getSubmittedQuestionnaires();
    submittedQuestionnaires.push({ hash: this.getQuestionnaireHash(restaurantId, reservationId, customerId), averageRating: averageRating ?? 0, submissionId });
    this.setItem('SubmittedQuestionnaires', submittedQuestionnaires);
  }

  getSubmittedQuestionnaireAverageRating(restaurantId: string, reservationId: string | null, customerId: string | null) {
    const submittedQuestionnaires: {hash: number, averageRating: number, submissionId: number}[] = this.getSubmittedQuestionnaires();
    const questionnaire = submittedQuestionnaires.find(q => q.hash === this.getQuestionnaireHash(restaurantId, reservationId, customerId));

    if (questionnaire == null) {
      return null;
    }

    return questionnaire.averageRating;
  }

  getSubmittedQuestionnaireId(restaurantId: string, reservationId: string | null, customerId: string | null) {
    const submittedQuestionnaires: {hash: number, averageRating: number, submissionId: number}[] = this.getSubmittedQuestionnaires();
    const questionnaire = submittedQuestionnaires.find(q => q.hash === this.getQuestionnaireHash(restaurantId, reservationId, customerId));

    if (questionnaire == null) {
      return null;
    }

    return questionnaire.submissionId;
  }

  private getSubmittedQuestionnaires() {
    let submittedQuestionnairesValue = this.getItem('SubmittedQuestionnaires') ?? '';

    if (Common.isNullOrEmpty(submittedQuestionnairesValue)) {
      submittedQuestionnairesValue = '[]';
    }

    return JSON.parse(submittedQuestionnairesValue);
  }

  private getQuestionnaireHash(restaurantId: string, reservationId: string | null, customerId: string | null) {
    return Common.hash(`${restaurantId}${reservationId ?? ''}${customerId ?? ''}`);
  }

  private getItem(item: LocalStorageItem) {
    return localStorage.getItem(item);
  }

  private setItem(item: LocalStorageItem, value: any) {
    const stringifiedValue = typeof value === 'object' ? JSON.stringify(value) : `${value}`;
    localStorage.setItem(item, stringifiedValue);
  }
}
